import React from 'react';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';
import { Separator } from '../../../../../../../CommonComponents/OPL/Separator/Separator';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Options, WhatIfDTO } from './EstatePlanningCharitableDonations.meta';
import { DonationFieldArray } from './DonationFieldArray';

interface Props {
  Title: string;
  WhatIf: WhatIfDTO;
  options: Options;
}

export const EstatePlanningCharitableDonations = ({ Title, options }: Props) => {
  return (
    <>
      <Text fontSize="h5" fontWeight={600} px="12" py="16">
        What-if...
      </Text>

      <Separator />

      <Box display="flex" flexDirection="column" p={12} style={{ gap: 16 }}>
        <Text fontSize="h6" fontWeight={500}>
          {Title}
        </Text>

        <DonationFieldArray options={options} />
      </Box>
    </>
  );
};
